<template>
  <div class="m-row">
    <div class="m-col" v-for="i in 2" :key="i">
      <div class="m-card">
        <div class="card-frist">
          <img src="@/assets/images/Unicorn/add_stock.gif" alt="gif" />
          <div>
            <h2 class="text-b" style="color: var(--text-color-2)">
              Warehouse {{ i }}
            </h2>
            <div>
              <img src="@/assets/images/pin.png" alt="pin" />
              <address>
                {{ address[i] }}
              </address>
            </div>
            <div>
              <img src="@/assets/images/phone.png" alt="phone" />
              <p>Phone: {{ phone[i] }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="m-row">
        <div class="m-col">
          <div class="m-card" style="height: 100%">
            <div class="device" >
              <img src="@/assets/images/gateway_signal.gif" alt="geteway" />
              <div>
                <h3 class="text-b">Gateway</h3>
                <span style="font-size: 0.6rem">Active</span>
                <h3 class="text-b">{{ gateway[i] }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="m-col">
          <div class="m-card">
            <div class="device">
              <img src="@/assets/images/asset.png" alt="pin" />
              <div>
                <h3 class="text-b">Assets</h3>
                <span style="font-size: 0.6rem">Active</span>
                <h3 class="text-b">
                  {{ assetsActive[i] }} / {{ aseetsTotal[i] }}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="m-col">
          <div class="m-card" style="height: 100%">
            <div class="device">
              <img src="@/assets/images/qr_scan.gif" alt="phone" />
              <div>
                <h3 class="text-b">Check-out</h3>
                <h3 class="text-b">{{ aseetsTotal[i] - assetsActive[i] }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-card">
        <vs-table
          search
          pagination
          max-items="10"
          :data="fakeDataCom[i]"
          class="assets-table"
        >
          <template slot="header">
            <h3>Active Assets</h3>
          </template>
          <template slot="thead">
            <vs-th sort-key="name"> Name </vs-th>
            <vs-th sort-key="mac"> Mac Address </vs-th>
            <vs-th sort-key="model"> Type </vs-th>
            <vs-th sort-key="location"> Location </vs-th>
            <vs-th sort-key="battery"> Status </vs-th>
            <vs-th sort-key="dis"> Distance </vs-th>
            <vs-th sort-key="signal"> Signal </vs-th>
            <vs-th sort-key="battery"> Battery </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :state="data[indextr].status == 'normal'?null:data[indextr].status == 'alert'?'warning':'danger'"  :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>

              <vs-td :data="data[indextr].mac">
                {{ data[indextr].mac }}
              </vs-td>

              <vs-td :data="data[indextr].model">
                {{ data[indextr].model }}
              </vs-td>

              <vs-td :data="data[indextr].location">
                {{ data[indextr].location }}
              </vs-td>

              <vs-td :data="data[indextr].status">
                {{  data[indextr].status.charAt(0).toUpperCase() + data[indextr].status.slice(1) }}
              </vs-td>

              <vs-td :data="data[indextr].dis">
                {{ data[indextr].dis }}
              </vs-td>

              <vs-td :data="data[indextr].signal" style="text-align: center">
                <vs-icon
                  v-if="data[indextr].signal == 1"
                  icon="fiber_manual_record"
                  color="primary"
                ></vs-icon>
                <vs-icon v-else icon="rss_feed" color="gray"></vs-icon>
              </vs-td>

              <vs-td :data="data[indextr].battery" style="text-align: center">
                <!-- {{ data[indextr].battery }} -->
                <vs-icon
                  v-if="data[indextr].battery >= 90"
                  icon="battery_full"
                  color="primary"
                ></vs-icon>
                <vs-icon
                  v-else-if="data[indextr].battery >= 80"
                  icon="battery_6_bar"
                  color="primary"
                ></vs-icon>
                <vs-icon
                  v-else-if="data[indextr].battery >= 65"
                  icon="battery_5_bar"
                  color="primary"
                ></vs-icon>
                <vs-icon
                  v-else-if="data[indextr].battery >= 50"
                  icon="battery_4_bar"
                  color="primary"
                ></vs-icon>
                <vs-icon
                  v-else-if="data[indextr].battery >= 40"
                  icon="battery_3_bar"
                  color="warning"
                ></vs-icon>
                <vs-icon
                  v-else-if="data[indextr].battery >= 25"
                  icon="battery_2_bar"
                  color="warning"
                ></vs-icon>
                <vs-icon
                  v-else-if="data[indextr].battery >= 10"
                  icon="battery_1_bar"
                  color="danger"
                ></vs-icon>
                <vs-icon
                  v-else-if="data[indextr].battery >= 0"
                  icon="battery_0_bar"
                  color="danger"
                ></vs-icon>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fakeData: [[], [], []],
      phone: [0, "089 662 1933", "02 579 1111"],
      assetsActive: [0, 1476, 823],
      aseetsTotal: [0, 1500, 1000],
      gateway: [0, "300/300", "200/200"],
      address: [
        "",
        "อาคารพร้อมพันธุ์ 1 ชั้น 5 Lat Phrao Rd, Chom Phon, Chatuchak, Bangkok 10900",
        "2410 2 Phahonyothin Rd, Sena Nikhom, Chatuchak, Bangkok 10900",
      ],
      comIndex: 0,
    };
  },
  computed: {
    fakeDataCom: function () {
      return [[], this.fakeData[1], this.fakeData[2]];
    },
  },
  mounted() {
    for (let j = 1; j <= 2; j++) {
      for (let i = 1; i <= this.assetsActive[j]; i++) {
        let no = (i / 1000).toFixed(3);

        let data = {
          name: "vaporizer No." + i,
          mac: (j == 1 ? "AC983247" : "AC233FF0") + no.slice(2),
          model: "E8",
          location: "Zone " + Math.round(Math.random() * 30),
          status:
            Math.round(Math.random() * 10) < 3
              ? Math.round(Math.random() * 10) < 1
                ? "not found"
                : "alert"
              : "normal",
          dis: (Math.random() * 20).toFixed(3),
          signal: 1,
          battery: Math.round(Math.random() * (100 - 40) + 40),
        };
        this.fakeData[j].push(data);
      }
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.m-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  width: auto;
  max-width: 100%;
}
.m-col {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  width: auto;
  max-width: 100%;
  flex-grow: 1;
  flex-basis: 0;
}
.m-card {
  max-width: 100%;
  background-color: var(--background-color-sidebar);
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
.card-frist {
  display: grid;
  grid: auto/25% 75%;
  img {
    width: 100%;
  }
  div {
    div {
      display: grid;
      grid: auto/20px auto;
      gap: 5px;
      img {
        width: 100%;
      }
    }
    p {
      color: var(--text-color-2);
    }
  }
}
.device {
  display: grid;
  grid: auto/25% 75%;
  align-items: center;
  height: 100%;
  img {
    width: 100%;
    // height: 100px;
  }
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
address {
  font-style: italic;
}
.assets-table {
  overflow: auto;
}
.text-b {
  font-weight: bold;
}
@media only screen and (max-width: 1200px) {
  .m-row {
    flex-wrap: wrap;
  }
  .m-col {
    flex-wrap: wrap;
  }
}
</style>